// import { graphql, useStaticQuery, Link } from "gatsby";
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, navigate } from 'gatsby'
import UXDXLogo from 'src/images/uxdx-logo.svg'
import { useAuthService } from 'theme/services/auth/auth-service'
import { startAndEndDate } from 'src/utils/date-helpers'
import { MainMenu } from '../mainMenu2'
import { sortBy, isEqual } from 'lodash-es'
import { getEventLink, getConferenceLocation } from 'theme/utils/generic-helpers'
import { calculateConferenceStatus } from 'src/utils/session-helpers'
import CookieConsentBanner from 'src/components/CookieConsentBanner'
// import { LinkedinShareButton } from 'react-share'

function Header({ conference, conferenceLinks, inPerson }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [conferenceStatus, setConferenceStatus] = useState({
    started: false,
    ended: false,
    close: false,
  })
  const authService = useAuthService()
  const user = authService.user
  const authenticated = authService.authenticated
  // const stageDays = conference.data.Stage_Days
  const sessions = conference.data.Sessions

  const partners = conference.data.Partners
  const conferenceLocation = getConferenceLocation(conference)

  const handleSignOut = (e) => {
    e.preventDefault()
    authService.logout()
    navigate('/')
  }

  useEffect(() => {
    setConferenceStatus(calculateConferenceStatus(sessions))

    const timer = setInterval(() => {
      const tempConfStatus = calculateConferenceStatus(sessions)
      if (!isEqual(tempConfStatus, conferenceStatus)) setConferenceStatus(tempConfStatus)
    }, 1000 * 60)

    return () => clearInterval(timer)
  }, [])

  let eventAttendanceMode = 'Online'
  conference.data.Venue &&
    conference.data.Venue.map((venue) => {
      if (venue.data.Venue_Type !== 'Online') {
        eventAttendanceMode = 'Offline'
      }
    })

  const conferenceVenueType = sortBy(conference.data.Venue, 'data.Venue_Type').reduce(
    (initialValue, venue, index) => {
      const venueName = venue.data.Venue_Type === 'Online' ? 'Online' : venue.data.Venue_City
      const separator = index < conference.data.Conference_Venue_Type.length - 1 ? ', ' : ' and '
      if (index > 0) return initialValue + separator + venueName
      return venueName
    },
    '',
  )

  const HeaderLinks = () => {
    // if it is marketing then show all of the links
    // if (promotionalstage === 'marketing') {
    return (
      <>
        {conferenceLinks.speakers && (
          <Link
            to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'speakers')}
            className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
          >
            Speakers
          </Link>
        )}

        <Link
          to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'agenda')}
          className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
        >
          Agenda
        </Link>

        {partners && partners.length > 0 && conferenceLinks.partners && (
          <Link
            to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'partners')}
            className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
          >
            Partners
          </Link>
        )}

        {eventAttendanceMode === 'Offline' && (
          <Link
            to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'venue')}
            className="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-gray-700 focus:bg-white"
          >
            Venue
          </Link>
        )}
        {conferenceLinks.tickets && (
          <Link
            to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'tickets')}
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 bg-white hover:bg-gray-700 hover:text-white focus:outline-none focus:text-white focus:bg-transparent transition duration-150 ease-in-out"
          >
            Tickets
          </Link>
        )}
        {!conferenceLinks.tickets && conferenceLinks.externalTickets && (
          <a
            href={conferenceLinks.externalTickets}
            target="/_blank"
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 bg-white hover:bg-gray-700 hover:text-white focus:outline-none focus:text-white focus:bg-transparent transition duration-150 ease-in-out"
          >
            Tickets
          </a>
        )}
        {!inPerson && conference.data.Days_Away > -30 && (
          <Link
            to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'live/stage/main')}
            className={`${
              conferenceStatus.early && !conferenceStatus.close ? '' : 'opacity-50'
            } font-semibold text-white border-2 border-gray-100 px-3 py-2 text-base inline-flex items-center rounded-xl`}
          >
            {conferenceStatus.started && !conferenceStatus.ended && (
              <>
                <svg className="mr-1.5 h-2 w-2 text-white" fill="currentColor" viewBox="0 0 8 8">
                  <circle cx="4" cy="4" r="3" />
                </svg>
                Live
              </>
            )}
            {(!conferenceStatus.started || conferenceStatus.ended) && <>Event</>}
          </Link>
        )}
      </>
    )
  }

  return (
    <>
      <CookieConsentBanner />
      <nav
        data-cy="navbar"
        className="fixed bg-uxdx-700 sm:bg-gradient-to-r sm:from-uxdx-700 sm:via-sky-500 sm:to-sky-700 w-full z-30"
      >
        <MainMenu />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 ">
                <Link to="/">
                  <img className="h-10 w-10" src={UXDXLogo} alt="UXDX logo" />
                </Link>
              </div>
              <div className="mx-auto pl-2 pr-4 sm:pr-6 lg:pr-0 xl:pr-8 md:hidden lg:block">
                <div className="flex">
                  <Link
                    to={'/community/' + conference.data.Conference_Id}
                    className="xl:mr-4 my-2 px-3 py-2 rounded-md text-lg text-left font-medium leading-5 text-gray-100 focus:outline-none"
                  >
                    <span className="hidden sm:block truncate line-clamp-1">
                      {conference.data.Conference_Name}
                    </span>
                    <span className="block sm:hidden">UXDX Community Event</span>
                    <span className="text-sm text-gray-100">
                      {startAndEndDate(
                        conference.data.Conference_Start_Date,
                        conference.data.Conference_End_Date,
                      )}
                      , {conferenceVenueType}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-2 flex items-middle items-center xl:space-x-4">
                <HeaderLinks />
              </div>
            </div>
            <div className="-mr-2 flex md:hidden">
              {/* <!-- Mobile menu button --> */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-100 hover:text-gray-700 hover:bg-white focus:outline-none focus:bg-white focus:text-gray-700"
              >
                <span className="sr-only">Open conference list</span>
                <svg
                  className={`${mobileMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <svg
                  className={`${mobileMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* <!--
        Mobile menu, toggle classes based on menu state.

        Open: "block", closed: "hidden"
      --> */}
        <div className={`${mobileMenuOpen ? 'block' : 'hidden'} md:hidden overflow-auto`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <HeaderLinks />
          </div>

          <div className="mt-4 pt-4 pb-3 ml-2 mr-2 border-t border-white">
            {/* If not signed In */}
            <span className={`${authenticated ? 'hidden' : 'block'} px-2 pt-2 pb-3 space-y-1 sm:px-3`}>
              <Link
                data-cy="header-login-link"
                to="/login/"
                className="block px-3 py-2 rounded-md text-white font-medium text-base bg-gray-700 focus:outline-none focus:text-white"
              >
                Sign In
              </Link>
            </span>
            {/* If signed In */}
            <div className={`${authenticated ? 'block' : 'hidden'} `}>
              <div className="flex items-center px-5 space-x-3">
                <div className="space-y-1">
                  <div className="text-base font-medium leading-none text-white">
                    {user && (
                      <>
                        {user.firstName} {user.lastName}
                      </>
                    )}
                  </div>
                  <div className="text-sm font-medium leading-none text-gray-200">{user && user.email}</div>
                </div>
              </div>
              <div
                className="mt-3 px-2 space-y-1"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
              >
                <Link
                  to="/account/"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-100 focus:outline-none focus:text-white"
                  role="menuitem"
                >
                  Your Profile
                </Link>

                <div
                  onClick={handleSignOut}
                  data-cy="header-logout-link"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-100 focus:outline-none focus:text-white"
                  role="menuitem"
                >
                  Sign out
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

Header.propTypes = {
  conference: PropTypes.shape({
    data: PropTypes.shape({
      Conference_Id: PropTypes.string.isRequired,
      Conference_Name: PropTypes.string.isRequired,
      Type: PropTypes.string.isRequired,
      Location: PropTypes.string.isRequired,
      Conference_Venue_Type: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      Conference_Start_Date: PropTypes.string.isRequired,
      Conference_End_Date: PropTypes.string.isRequired,
      Days_Away: PropTypes.number.isRequired,
      Sessions: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Session_Id: PropTypes.string,
            Session_Status: PropTypes.string,
            UTC_Start_Time: PropTypes.string,
            UTC_End_Time: PropTypes.string,
            Session_Groups: PropTypes.arrayOf(
              PropTypes.shape({
                data: PropTypes.shape({
                  Delivery: PropTypes.string.isRequired,
                }).isRequired,
              }).isRequired,
            ).isRequired,
          }).isRequired,
        }).isRequired,
      ).isRequired,
      Partners: PropTypes.arrayOf(PropTypes.object),
      Venue: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Venue_Type: PropTypes.string.isRequired,
            Venue_City: PropTypes.string,
          }),
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
  conferenceLinks: PropTypes.shape({
    speakers: PropTypes.bool,
    partners: PropTypes.bool,
    tickets: PropTypes.bool,
  }).isRequired,
}

export default Header
